import Minimal from './component/screens/Minimal';
import './App.css';

function App() {
  return (
    <Minimal /> 
  );
}

export default App;
